import React, { type FC } from 'react';
import cn from 'clsx';
import { useTheme } from '../../contexts/Theme';
import { DH } from '../../utils/DataHook';
import { type FieldName } from '../../types/CardFieldName';
import s from './styles.scss';

// TODO: localize aria-label?
export const FieldLabel: FC<{
  fieldName: FieldName;
  text: string;
  className?: string;
  onClick(): void;
}> = (props) => {
  const theme = useTheme();
  const { onClick, fieldName, className } = props;

  return (
    <label data-hook={DH.Field.Label} className={cn(s.fieldLabel, className)} htmlFor={fieldName} onClick={onClick}>
      {props.text}
      {theme === 'standard' && <span aria-hidden> *</span>}
    </label>
  );
};
FieldLabel.displayName = 'FieldLabel';
